// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"2268d786","827":"ae0b8882"}[chunkId] + ".chunk.js";
};